module.exports = __webpack_public_path__ + "img/公域.1788d394.svg";